import { Stack, Text, Title } from "@mantine/core";

const Dashboard = () => {
  return (
    <Stack gap="xl">
      <Title order={1}>Admin Dashboard</Title>
      <Text c="dimmed">
        Select a section from the navigation menu to manage accounts.
      </Text>
    </Stack>
  );
};

export default Dashboard;
